<template>
  <v-card>
    <v-card-title class="align-start pb-0">
      <v-avatar color="primarylight" size="38">
        <v-icon size="24" color="white" class="rounded-0">mdi-home-city-outline</v-icon>
      </v-avatar>
      <v-spacer></v-spacer>

      <v-btn :to="{ name: 'immobile' }" small icon class="me-n3 mt-n1">
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="text-no-wrap text--primary mt-3">
      <p class="font-weight-semibold text-sm mb-1">Imóveis</p>

      <div class="d-flex align-end flex-wrap mb-2">
        <span class="font-weight-semibold text-2xl mr-1">{{ data.immobiles.length }} </span>
        <small class="mb-1">
          <span v-if="totalArea > 0">/</span>
          {{ totalArea }} m²
        </small>
      </div>
      <p class="text-xs text--secondary mb-0">Cadastros</p>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    totalArea() {
      return this.data.immobiles.reduce((acc, immobile) => {
        return acc + (immobile.area || 0)
      }, 0)
    },
  },
}
</script>

<style lang="scss" scoped>
</style>